import createSlug from 'slug'
import { mergeObjects } from '@utils/objects'

export type SlugOptions = Extract<Parameters<typeof createSlug>[1], object>;

/**
 * Slugify like "pretty" but keeping dots
 * @link {https://github.com/Trott/slug/blob/c35db3ec8e80bd71e527cc971dfa4da4c97f95fd/slug.js#L91C53-L91C85}
 *
 * @param text
 * @returns
 */
export function slugifyFilename(text: string): string {
  const options: SlugOptions = {
    mode: 'rfc3986',
    remove: /[^A-Za-z0-9\s.]/g,
  };

  return slugify(text, options);
}

/**
 * Slugify
 *
 * @param text
 * @param options
 * @returns
 */
export function slugify(text: string, options?: SlugOptions): string {
  const defaults = {
    replacement: '-',
    lower: true,
    mode: 'pretty',
  };

  const args = options ? mergeObjects(defaults, options) : defaults;

  return createSlug(text, args);
}

/**
 * Slugify with underline
 *
 * @param text
 * @param options
 * @returns
 */
export function slugify_(text: string, options?: SlugOptions): string {
  return slugify(text, {...options, replacement: '_'});
}

/**
 * Slugify with dots
 *
 * @param text
 * @param options
 * @returns
 */
export function slugify_with_dots(text: string, options?: Exclude<SlugOptions, 'replacement'>): string {
  const placeholder = 'dotdotdotdotdotdotdotdotdot';
  const string = text.replaceAll('.', placeholder);
  return slugify(string, {...options, replacement: '-'}).replaceAll(placeholder, '.');
}

/**
 * Create a unique slug
 *
 * @param text
 * @param list
 * @param slugified
 * @returns
 */
export function createUniqueSlug(text: string, list: string[], slugified: boolean = false): string {
  const slug = slugified ? text : slugify(text);

  const set = new Set(list);
  if (! set.has(slug)) {
    return slug;
  }

  let retries: number = 2;
  while (set.has(`${slug}-${retries}`)) {
    retries++;
  }

  return `${slug}-${retries}`;
}
